<template>
  <form class="operacaoForm row wrap align-center" onsubmit="return false" @submit="send">
    <div class="grid-3 grid-12-s column-s">
      <label>Nome</label>
      <input v-model="form.nome" placeholder="Nome" />
    </div>
    <div class="grid-3 grid-12-s">
      <label>Visibilidade</label>
      <select v-model="form.visibilidade">
        <option>SELECIONE</option>
        <option value="tudo">Todos os jobs</option>
        <option value="operacao">Somente os jobs da operação atual</option>
        <option value="meus">Somente seus próprios jobs</option>
      </select>
    </div>
    <div class="grid-3 grid-12-s">
      <label>Nome do Responsável</label>
      <input v-model="form.nome_responsavel" placeholder="Nome do Responsável" />
    </div>
    <div class="grid-3 grid-12-s">
      <label>E-mail do Responsável</label>
      <input type="email" v-model="form.email_responsavel" placeholder="Nome do Responsável" />
    </div>
    <div class="grid-3 grid-12-s">
      <label>Telefone do Responsável</label>
      <input type="text" v-mask="'(##) #####-####'" v-model="form.fone_responsavel"
        placeholder="Telefone do Responsável" />
    </div>
    <Button type="submit" :loader="loader" layout="green-go"><i class="fa fa-edit" />{{ operacao ? "ATUALIZAR" :
      "ADICIONAR" }}</Button>
    <Button v-if="operacao && operacao.status == 'ativo'" type="button" @click="del" :loader="loader" layout="red-go"><i
        class="fa fa-trash" /> DESATIVAR</Button>
    <Button v-if="operacao && operacao.status == 'inativo'" type="button" @click="activate" :loader="loader"
      layout="green-go white"><i class="fa fa-check" /> ATIVAR</Button>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import format from '@/utils/format'

export default {
  name: "OperacaoForm",
  components: { Button },
  props: { operacao: Object, reload: Function, client: Number },
  data() {
    return {
      loader: false,
      form: { visibilidade: "" },
    };
  },
  methods: {
    ...mapActions("admin", ["CLIENT_OPERACAO", "CLIENT_OPERACAO_ACTIVE"]),
    async send() {
      this.loader = true;
      let data = { ...this.form, ID: this.client }
      data.fone_responsavel = format.clear(data.fone_responsavel)
      data.t = this.operacao ? 'put' : 'post'
      await this.CLIENT_OPERACAO(data)
      this.loader = false;
      this.reload()
    },
    async activate() {
      this.loader = true
      await this.CLIENT_OPERACAO_ACTIVE({ ID: this.client, id: this.form.id })
      this.loader = false;
      this.reload()
    },
    async del() {
      if (confirm(`Deseja desativar esta operação: ${this.form.nome}?`)) {
        this.loader = true;
        await this.CLIENT_OPERACAO({ ID: this.client, id: this.form.id, t: 'delete' })
        this.loader = false
        this.reload()
      }
    },
  },
  beforeMount() {
    if (this.operacao) {
      this.form = this.operacao
    }
  }
};
</script>
<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.operacaoForm
  @include form
  padding: 12px 20px
  border-radius: 12px
  background: #f1f1f8
  @include border
  .grid-3
    margin-bottom: 12px
  .button-red-go, .white
    margin-left: 12px
</style>
